<template>
  <main class="main">

    <modal 
      :resizable="false" 
      :scrollable="false" 
      :max-width="600" 
      height="auto" 
      :size="'600px'" 
      :close="false"
      style="z-index: 10"
      class="modal-preview p-4" 
      name="changeClaimStatusModal"      
      >
      <div class="p-3">  

      <h5 class="modal-title mt-3 mb-2">
        Motive
      </h5>
        
      <p>
        {{ claimSelected.title }}
      </p>

      <h5 class="modal-title mt-3 mb-2">
        Detail
      </h5>

      <p>
        {{ claimSelected.details }}
      </p>

      <!-- select with 3 options to change status of claim -->
      <h5 class="modal-title mt-3 mb-2">
        Status
      </h5>
      <select v-model="claimSelected.status" class="form-control">
        <option :value="'new_claim'">{{ $t("lang.label.claim_new") }}</option>
        <option :value="'on_going'">{{ $t("lang.label.claim_approved") }}</option>
        <option :value="'closed'">{{ $t("lang.label.claim_rejected") }}</option>
        <option :value="'absent_meeting'">{{ $t("lang.label.claim_absent") }}</option>
      </select>

      <div class="d-flex justify-content-end mt-3">
        <button 
          class="btn btn-secondary mr-2" 
          @click="closeModal"
          :disabled="loadingSave"
        >
          {{ $t("lang.button.cancel") }}
        </button>
        <button 
          class="btn btn-primary" 
          @click="saveClaimStatus"
        >
          <span
              v-if="loadingSave"
              class="spinner-border spinner-border-sm mr-2"
          ></span>
          {{ $t("lang.button.save") }}
        </button>
      </div>
    </div>
    </modal>
        
    <section>
      <modal
        :resizable="false"
        :scrollable="true"
        :max-width="900"
        height="auto"
        :size="'900px'"
        class="modal-preview p-4"
        name="claimPayloadModal"
      >
        <div class="p-3">
          <h5 class="modal-title mb-3">N8N Payload</h5>
          <LoadingSpinner v-if="payloadLoading" />
          <pre v-else class="claim-payload-json">{{ payloadPreview }}</pre>
          <div class="d-flex justify-content-end mt-3">
            <button class="btn btn-secondary" @click="$modal.hide('claimPayloadModal')">
              {{ $t("lang.button.close") || 'Close' }}
            </button>
          </div>
        </div>
      </modal>

      <modal
        :resizable="false"
        :scrollable="true"
        :max-width="900"
        height="auto"
        :size="'900px'"
        class="modal-preview p-4"
        name="claimSalesridgeModal"
      >
        <div class="p-3">
          <h5 class="modal-title mb-3">SalesRidge Response</h5>
          <LoadingSpinner v-if="salesridgeLoading" />
          <pre v-else class="claim-payload-json">{{ salesridgePreview }}</pre>
          <div class="d-flex justify-content-end mt-3">
            <button class="btn btn-secondary" @click="$modal.hide('claimSalesridgeModal')">
              {{ $t("lang.button.close") || 'Close' }}
            </button>
          </div>
        </div>
      </modal>

      <!-- Filter for Account Manager (only visible for superAdmin) -->
      <h4 class="ml-3">Claims</h4>
      <div class="row my-3 px-2" v-if="hasPermissions('superAdmin') && !isOliverSale()">
        <div class="col-md-6">
          <div class="card p-2">
            <div class="row">
              <div class="col-12 col-md-4" v-if="oliverSalesLoaded">
                <span class="font-weight-bold mb-2">Account Manager:</span>
                <IndustrySearch 
                  :option_list="userOliverSales" 
                  :default_values="userOliverSale"
                  :key="3"
                  :multiple="false" 
                  :isDisabled="savingOliverUser" 
                  @selected="selectOliverSale" 
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <Tabs 
        :tabSelected="tabSelected" 
        :tabs="tabs" 
        @change="changeTab($event)" 
        class="mx-3"
      />


      <LoadingSpinner v-if="loading" />

      <div class="row my-4 px-2" v-if="!loading">
        <!-- Tabla de datos -->
        <div class="col-md-12 w-100 mb-3 card p-2" v-if="!loading">
          <div class="mx-0 px-0 table-responsive">
            <Table
              class="mx-2 w-100"
              :headers="headers"
              :cols="cols"
              :data="claims"
              :checkbox="false"
              :notselect="true"
              :model="model"
              @goToOpportunity="goToOpportunity"
              @goToClient="goToClient"
              @goToTarget="goToTarget"
              @goToEditStatus="goToEditStatus"
              @runJudge="runJudge"
              @loadClaimContactsInformation="loadClaimContactsInformation"
              @checkPayload="checkPayload"
              @checkSalesridge="checkSalesridge"
            >
            </Table>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { adminService, usersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tabs from "@/components/Common/Tabs.vue";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";

export default {
  name: 'LinkClaims',
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      headerTab: state => state.header.tab
    }),
  },

  data() {
    const judgeCol = {
      loading_data: [],
      disabled: [],
    };
    const salesridgeCol = {
      loading_data: [],
      disabled: [],
    };
    return {
      judgeCol,
      salesridgeCol,
      tabSelected: 1,
      tabs: {
        1: {
          id: 1,
          name: this.$t("lang.label.claim_new"),
        },
        2: {
          id: 2,
          name: this.$t("lang.label.claim_approved"),
        },
        3: {
          id: 3,
          name: this.$t("lang.label.claim_rejected"),
        },
        4: {
          id: 5,
          name: 'Absent meeting',
        },
      },
      loadingSave: false,
      claims: [],
      payloadLoading: false,
      payloadPreview: '',
      salesridgeLoading: false,
      salesridgePreview: '',
      claimSelected: {
        id: null,
        reason_title: '',
        details: '',
        status: '',
        created_at: '',  
      },
      loading: true,
      filters: {},
      oliverSalesLoaded: false,
      savingOliverUser: false,
      userOliverSale: ['0'],
      previewUserOliverSale: "0",
      userOliverSales: [{ id: "0", label: "All" }],
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [      
         [
            {
              value_label: "business_name",
              value_emit: "link_id",
              class: "text-primary",
              type: "emit",
              emit: "goToOpportunity",
            },
        ],
        [
          {
            value1: "link_status_reason_id",
            value2: "amount",
            value3: "real_event_date",
            value4: "event_date",
            value5: "billing_status",
            type: "statusMeeting"
          },    
        ],        
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToClient",
          },
        ],
        [
          {
            value: "account_manager",
          },
        ],       
        [
          {
            value_label: "target_name",
            value_emit: "target_id",
            class: "text-primary",
            type: "emit",
            emit: "goToTarget",
          },
        ],     
        [
          {
            value: "title",
            translate: "lang.menu",
          },
        ],
        [
          {
            value: "details",
          },
        ],
        [
          {
            value: "created_at",
          },
        ],
        [
        {
            value: "status",
            type: "itemBadge",
            class: "badge badge-primary",
            emit: "goToEditStatus",
            colors: [
              {
                id: 'new_claim',
                label: this.$t("lang.label.claim_new"),
                bgColor: "#FF0000",
                textColor: "#FFFFFF",
              },
              {
                id: 'on_going',
                label: this.$t("lang.label.claim_approved"),
                bgColor: "#ffc107",
                textColor: "#FFFFFF",
              },
              {
                id: 'closed',
                label: this.$t("lang.label.claim_rejected"),
                bgColor: "#000000",
                textColor: "#FFFFFF",
              },
              {
                id: 'absent_meeting',
                label: this.$t("lang.label.claim_absent"),
                bgColor: "#17a2b8",
                textColor: "#FFFFFF",
              },

            ],
          },    
        ],
        // Judge run button (Ticket 4)
        [
          {
            type: 'btnAction',
            value: 'link_event_id',
            name: 'judge_btn_label',
            btnId: 'link_event_id',
            emit: 'runJudge',
            loading_data: judgeCol.loading_data,
            disabled: judgeCol.disabled,
            tag_value: 'judge_tag',
            tag_tooltip_value: 'judge_explanation',
          },
        ],
        [
          {
            value: "contacts_information",
            type: "claimContactsInformation",
          },
        ],
        [
          {
            type: 'btnAction',
            value: 'id',
            name: 'payload_btn_label',
            btnId: 'id',
            emit: 'checkPayload',
            loading_data: [],
            disabled: [],
          },
        ],
        [
          {
            type: 'btnAction',
            value: 'id',
            name: 'salesridge_btn_label',
            btnId: 'id',
            emit: 'checkSalesridge',
            loading_data: salesridgeCol.loading_data,
            disabled: salesridgeCol.disabled,
            visible_value: 'has_salesridge_response',
          },
        ],
      ],
      headers: [    
        {
            label: "Opportunity",
            class: "overflowhide",
        },
        {
            label: "Meeting",
            class: "overflowhide",
        },     
        {
          label: this.$t("lang.label.client"),
          percentage: "15%",
          class: "overflowhide",
          id: 3,
        },
        {
          label: "Account Manager",
          percentage: "20%",
          class: "overflowhide",
          id: 4,
        }, 
        {
          label: "Target",
          percentage: "20%",
          class: "overflowhide",
          id: 4,
        },  
             
        {
          label: "Reason",
          percentage: "15%",
          class: "overflowhide",
          id: 2,
        },
        {
          label: "Details",
          percentage: "20%",
          class: "overflowhide",
          id: 6,
        },
        {
          label: "Created At",
          percentage: "15%",
          class: "overflowhide",
          id: 7,
        },
        {
          label: "Status",
          percentage: "10%",
          class: "overflowhide",
          id: 5,
        },
        {
          label: "Judge",
          percentage: "10%",
          class: "overflowhide",
        },
        {
          label: "Contacts Information",
          percentage: "25%",
          class: "overflowhide",
        },
        {
          label: "Payload",
          percentage: "10%",
          class: "overflowhide",
        },
        {
          label: "SalesRidge",
          percentage: "10%",
          class: "overflowhide",
        },
      ],
    };
  },
  components: {
    Table,
    LoadingSpinner,
    Tabs,
    IndustrySearch,
  },
  created() {
    // this.setCurrentRoute({ page: 'claims' });
    // this.setCurrentRouteChild({ child: '' });
    if(this.isOliverSale()) {
      this.userOliverSale = [this.currentUser.id];
      this.previewUserOliverSale = this.currentUser.id;
    }
  },
  mounted() {    
    this.getData();
    this.updateHeader('claims');
    if (this.hasPermissions('superAdmin')) {
      this.getUserOliverSales();
    }
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild"
    }),
    updateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
    goToClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    closeModal() {      
      this.$modal.hide("changeClaimStatusModal");     
    },
    goToEditStatus(id){      
      const item = this.claims.find(claim => claim.id === id);
      if(item){
        const {id, title, details, status, created_at} = item;
        this.claimSelected = {
          id: id,
          title: title,
          details: details,
          status: status,
          created_at,
        };
        this.$modal.show('changeClaimStatusModal');
      }
    },
    isOliverSale() {
      return (
        this.currentUser.role_id == 1 &&
        this.currentUser.user_constraint_id == 2
      );
    },
    goToTarget(target_id) {
      let url = "/orders/" + target_id;
      window.open(url, "_blank");
    },
    goToOpportunity(link_id) {
      let url = "/opportunities/" + link_id;
      window.open(url, "_blank");
    },

    changeTab(value) {
      if (value == this.tabSelected) return;
      this.tabSelected = value;
      this.getData();
    },
    getStatusFromTab(tabId) {
      const statusMap = {
        1: 'new_claim',
        2: 'claim_approved',
        3: 'closed',
        5: 'absent_meeting',
      };
      return statusMap[tabId] || 'new_claim';
    },
    filterClaimsByTab(claims) {
      // if (this.tabSelected === 1 || this.tabSelected === 4) {
        // if (this.tabSelected == 1) {
        //   Nouvelle réclamation
        //   return claims.filter(claim =>
        //   (claim.billing_status != 'pay_declined')
        //   );
        // } 
      // else if (this.tabSelected == 4) {
      //     // A triater Reclamation
      //     return claims.filter(claim =>
      //       claim.real_event_date !== null && claim.real_event_date !== '' && (claim.billing_status == 'pay_paid' || claim.billing_status == 'next_pay')
      //     );
      //   }
      // }
      // if(this.tabSelected == 4){
      //     return claims.filter(claim =>
      //       claim.status == 'new_claim'
      //     );
      // }
      
      // For other tabs (3, 4), return all claims without additional filtering
      // return claims;
    },
    saveClaimStatus() {
      this.loadingSave = true;

      const dataToSave = {
        id: this.claimSelected.id,
        status: this.claimSelected.status,
      };
      adminService.updateStatusClaimToMeeting(dataToSave)
        .then((res) => {
          if (res !== undefined && res) {
            this.loadingSave = false
            this.$modal.hide("changeClaimStatusModal");
            this.getData();
          }
        })
        .catch((error) => {
          console.error("Error updating claim status:", error);
        });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getUserOliverSales() {
      usersService
        .getUserOliverSales(true, 0, true)
        .then((res) => {
          if (res.result.length > 0) {
            const userOliverSalesWithlabel = res.result.map((el) => ({
              ...el,
              label:  el.name + ", " + el.lastname,
            }));
            this.userOliverSales.push(...userOliverSalesWithlabel);
            this.oliverSalesLoaded = true;
          }
        })
        .catch((err) => console.error(err));
    },
    selectOliverSale(value) {
      const userOliverSaleId = value.id;
      
      if (userOliverSaleId != this.previewUserOliverSale) {
        this.savingOliverUser = true;
        this.previewUserOliverSale = userOliverSaleId;
        this.userOliverSale = userOliverSaleId !== "0" ? [userOliverSaleId] : ['0'];
        this.savingOliverUser = false;
        // Refresh data with new filter
        this.getData();
      }
    },
    getData(filterStatus = false) {
      this.loading = true;

      // Use status from selected tab if no filterStatus is provided
      const status = filterStatus || this.getStatusFromTab(this.tabSelected);
      
      //const typeNewClaim = this.tabs[2].id == ;
      
      this.filters = {
        status: status,
        limit: 100,
        offset: 0,
      };

      // Add Account Manager filter if selected and user is superAdmin
      if (this.hasPermissions('superAdmin') && this.userOliverSale && this.userOliverSale[0] !== "0") {
        this.filters.oliver_sale = this.userOliverSale[0];
      }

      adminService.getAllClaims(this.filters)
        .then((res) => {
          if (res !== undefined && res) {
            this.claims = res;
            this.setupClaimActions();
            //this.claims = this.filterClaimsByTab(res);
            this.loading = false;
          } else {
            this.claims = [];
            this.loading = false;
          }
        })
        .catch((error) => {
          console.error("Error fetching claims:", error);
          this.claims = [];
          this.loading = false;
        });
    },

    // Ticket 3 & 4 — compute button labels and judge disabled state after loading claims
    setupClaimActions() {
      this.claims = this.claims.map(claim => {
        const companyOk  = claim.linkedin_company_status  === 'success';
        const contactsOk = claim.linkedin_contacts_status === 'success';
        const linkedinDone = companyOk && contactsOk;

        let judgeTag = null;
        if (claim.judge_decision === 'valid')   judgeTag = 'Valid';
        if (claim.judge_decision === 'invalid') judgeTag = 'Invalid';

        return {
          ...claim,
          contacts_information: claim.contacts_information || {
            claim_id: claim.id,
            loading: false,
            loaded: false,
            company: {
              name: claim.business_name || 'Company',
              linkedin_url: null,
              linkedin_status: 'pending',
            },
            contacts: [],
          },
          judge_btn_label: 'Run Judge',
          payload_btn_label: 'Check Payload',
          salesridge_btn_label: 'View JSON',
          judge_tag: judgeTag,
          judge_explanation: claim.judge_explanation || null,
        };
      });

      this.recomputeActionState();
    },

    recomputeActionState() {
      this.salesridgeCol.disabled = this.claims
        .filter(claim => !claim.has_salesridge_response)
        .map(claim => claim.id);

      this.judgeCol.disabled = this.claims
        .filter(claim => !(claim.linkedin_company_status === 'success' && claim.linkedin_contacts_status === 'success'))
        .map(claim => claim.link_event_id);
    },

    loadClaimContactsInformation(claimId) {
      const id = Number(claimId);
      if (!id) return;

      const idx = this.claims.findIndex(claim => Number(claim.id) === id);
      if (idx === -1) return;

      const claim = this.claims[idx];
      const currentInfo = claim.contacts_information || {};

      if (currentInfo.loading || currentInfo.loaded) {
        return;
      }

      this.$set(this.claims, idx, {
        ...claim,
        contacts_information: {
          ...currentInfo,
          claim_id: id,
          loading: true,
          loaded: false,
        },
      });

      adminService.getClaimsContactsInformation([id])
        .then(result => {
          if (!result || typeof result !== 'object') return;

          const refreshedClaim = this.claims[idx];
          const info = result[id] || result[String(id)];
          if (!refreshedClaim || !info) {
            this.$set(this.claims, idx, {
              ...refreshedClaim,
              contacts_information: {
                ...(refreshedClaim && refreshedClaim.contacts_information ? refreshedClaim.contacts_information : {}),
                claim_id: id,
                loading: false,
                loaded: true,
              },
            });
            return;
          }

          this.$set(this.claims, idx, {
            ...refreshedClaim,
            contacts_information: {
              ...(info.contacts_information || refreshedClaim.contacts_information || {}),
              claim_id: id,
              loading: false,
              loaded: true,
            },
            linkedin_company_status: info.linkedin_company_status,
            linkedin_contacts_status: info.linkedin_contacts_status,
            has_salesridge_response: !!info.has_salesridge_response,
            judge_decision: info.judge_decision || null,
            judge_explanation: info.judge_explanation || null,
            judge_tag:
              info.judge_decision === 'valid'
                ? 'Valid'
                : info.judge_decision === 'invalid'
                  ? 'Invalid'
                  : refreshedClaim.judge_tag,
          });

          this.recomputeActionState();
        })
        .catch(error => {
          console.error('Error fetching contacts information:', error);
          const failedClaim = this.claims[idx];
          if (failedClaim) {
            this.$set(this.claims, idx, {
              ...failedClaim,
              contacts_information: {
                ...(failedClaim.contacts_information || {}),
                claim_id: id,
                loading: false,
                loaded: false,
              },
            });
          }
        });
    },

    checkPayload(claim_id) {
      this.payloadLoading = true;
      this.payloadPreview = '';
      this.$modal.show('claimPayloadModal');
      adminService.getClaimN8nPayload(claim_id)
        .then(payload => {
          this.payloadPreview = JSON.stringify(payload, null, 2);
        })
        .catch(error => {
          this.payloadPreview = JSON.stringify(error, null, 2);
        })
        .finally(() => {
          this.payloadLoading = false;
        });
    },

    checkSalesridge(claim_id) {
      this.salesridgeLoading = true;
      this.salesridgePreview = '';
      this.salesridgeCol.loading_data.push(claim_id);
      this.$modal.show('claimSalesridgeModal');
      adminService.getClaimSalesridgeResponse(claim_id)
        .then(payload => {
          this.salesridgePreview = JSON.stringify(payload, null, 2);
        })
        .catch(error => {
          this.salesridgePreview = JSON.stringify(error, null, 2);
        })
        .finally(() => {
          this.salesridgeLoading = false;
          const i = this.salesridgeCol.loading_data.indexOf(claim_id);
          if (i > -1) this.salesridgeCol.loading_data.splice(i, 1);
        });
    },

    // Ticket 4 — "Run Judge" button handler
    runJudge(link_event_id) {
      if (this.judgeCol.loading_data.includes(link_event_id)) {
        return;
      }

      this.judgeCol.loading_data.push(link_event_id);
      adminService.runJudge(link_event_id)
        .then(res => {
          const idx = this.claims.findIndex(c => c.link_event_id == link_event_id);
          if (idx !== -1) {
            if (res && res.queued) {
              this.$set(this.claims, idx, {
                ...this.claims[idx],
                judge_tag:         'Sent',
                judge_explanation: res.message || 'Judge webhook sent. Waiting callback decision.',
                judge_btn_label:   'Run Judge',
              });
              return;
            }
            const decision    = res.decision    || null;
            const explanation = res.explanation || null;
            const judgeTag    = decision === 'valid' ? 'Valid' : decision === 'invalid' ? 'Invalid' : 'Error';
            this.$set(this.claims, idx, {
              ...this.claims[idx],
              judge_decision:    decision,
              judge_tag:         judgeTag,
              judge_explanation: explanation,
              judge_btn_label:   'Run Judge',
            });
          }
        })
        .catch(err => {
          console.error('Judge run error:', err);
          const idx = this.claims.findIndex(c => c.link_event_id == link_event_id);
          if (idx !== -1) {
            this.$set(this.claims, idx, {
              ...this.claims[idx],
              judge_tag:         'Error',
              judge_explanation: err.message || 'An error occurred',
              judge_btn_label:   'Run Judge',
            });
          }
        })
        .finally(() => {
          const i = this.judgeCol.loading_data.indexOf(link_event_id);
          if (i > -1) this.judgeCol.loading_data.splice(i, 1);
        });
    },
  },
};
</script>

<style scoped>
.claim-payload-json {
  max-height: 70vh;
  overflow: auto;
  white-space: pre-wrap;
  background: #111827;
  color: #e5e7eb;
  border-radius: 6px;
  padding: 16px;
  font-size: 12px;
}
</style>

